import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../../Layout/Sidebar";
import loading from "../../../Assets/Animations/loading.gif";
import TableOfContents from './LocalComponents/TableOfContents';
import styles from './Guides.module.scss';
import { userApi } from '../../../Utils/API';
import { GRAPHQL_PROXY } from '../../../Utils/Endpoints';
import { formatLastUpdated } from '../../../Utils/formatDate';
import { sanitizeHtml } from '../../../Utils/sanitize';

const Guides = () => {
  const { guideId } = useParams();
  const [guideContent, setGuideContent] = useState(null);
  const [guideApiData, setGuideApiData] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Function for calling guide page data from Orchid Core CMS
  async function GetGuideData() {
    const data = `
      {
        guidesPage {
          displayText
          list {
            contentItems {
              ... on Guides {
                displayText
                list {
                  contentItems {
                    displayText
                    ... on GuidesContentPage {
                      displayText
                      htmlBody {
                        html
                      }
                      class
                      modifiedUtc
                    }
                  }
                }
              }
              displayText
            }
          }
        }
      }`;

    const token_type = localStorage.getItem("token_type");
    const access_token = localStorage.getItem("access_token");

    // if (!token_type || !access_token) {
    //   throw new Error("Authorization token not found.");
    // }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${token_type} ${access_token}`,
      },
    };

    const body = { query: data };

    try {
      const resp = await userApi.post(GRAPHQL_PROXY, body, config);
      if (resp.data && resp.data.data && resp.data.data.guidesPage) {
        setGuideApiData(resp.data.data.guidesPage[0]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    GetGuideData();
  }, []);

  useEffect(() => {
    if (guideApiData) {
      const id = guideId || 'developer-platform-overview';
      let foundContent = null;
      
      guideApiData.list.contentItems.forEach(section => {
        if (section.list && section.list.contentItems) {
          section.list.contentItems.forEach(page => {
            const pageId = page.displayText.toLowerCase().replace(/[^a-z0-9]+/g, '-');
            if (pageId === id) {
              foundContent = {
                html: page.htmlBody.html,
                modifiedUtc: page.modifiedUtc,
              };
            }
          });
        }
      });

      if (foundContent) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(foundContent.html, 'text/html');
        const headings = doc.querySelectorAll('h1, h2, h3');
        const toc = [];

        headings.forEach(heading => {
          const title = heading.textContent;
          const id = title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
          const level = parseInt(heading.tagName.substring(1), 10);
          heading.id = id;
          toc.push({ href: `#${id}`, title, level });
        });

        setGuideContent({
          htmlContent: doc.body.innerHTML,
          toc: toc,
          modifiedUtc: foundContent.modifiedUtc,
        });
      } else {
        setGuideContent(null);
      }
    }
  }, [guideApiData, guideId]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  if (!guideContent) {
    return (
      <div className={styles.loadingContainer}>
        <img src={loading} alt="loading..." />
      </div>
    );
  }

  return (
    <div className={styles.guidesPage}>
      <button className={styles.hamburger} onClick={toggleSidebar}>
        <i className="material-icons">segment</i>
      </button>
      <div className={styles.mainContent}>
        <Sidebar menuData={guideApiData} isOpen={isSidebarOpen} onClose={toggleSidebar} />
        {isSidebarOpen && <div className={styles.overlay} onClick={toggleSidebar}></div>}
        <main className={styles.contentArea}>
          <div className={styles.contentWrapper}>
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(guideContent.htmlContent) }} />
          </div>
          {guideContent.modifiedUtc && (
            <div className={styles.lastUpdated}>
              Last Updated: {formatLastUpdated(guideContent.modifiedUtc)}
            </div>
          )}
        </main>
        <div className={styles.tocContainer}>
          <TableOfContents items={guideContent.toc} />
        </div>
      </div>
    </div>
  );
};

export default Guides;